module.exports = __webpack_public_path__ + "img/ybsj.79d02345.png";